var Settings = {};
if (window.YAMASTERS_FRONTEND) {
    Settings = window.YAMASTERS_FRONTEND;
}

var Rating = {
    checkRating: function(){
		$('[data-yam-rating=true] label svg').on('click', function (e) {
			let parent = this.closest('[data-yam-rating]');
			$(parent).find('label').each(function () {
				$(this).removeClass('active');
			});
			$($(this).parent()).addClass('active');
		});
	}
};

require('__scss/rating.scss');	
EXE(function(){
    Rating.checkRating();
    //if (Settings.debug === true) {
        //console.log('Ratings include success!');
    //}
});

$('body').on('ajaxResponse', function() {
    Rating.checkRating();
});

module.exports = Rating;


// WEBPACK FOOTER //
// ./libs/rating.js